// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-section[data-v-fe4ce1ae]{padding:0!important;overflow:hidden}.confirmation-dialog__subtitle[data-v-fe4ce1ae]{font-size:24px!important;font-weight:600!important;line-height:1.33!important;letter-spacing:normal!important}.min-h-300[data-v-fe4ce1ae]{min-height:150px}", ""]);
// Exports
module.exports = exports;
